import { ItemsParameters } from '@common/Product/AddToFavorites/types';
import { loadSession, saveSession, removeSession } from '@helpers/sessionStorage';

const TRACK_ITEMS_PARAMETERS = 'items_parameters';

export const getItemsParameters = () => loadSession(TRACK_ITEMS_PARAMETERS);

export const setItemsParameters = (items: ItemsParameters) => saveSession(TRACK_ITEMS_PARAMETERS, items);

export const removeItemsParameters = () => removeSession(TRACK_ITEMS_PARAMETERS);

export const itemsParametersTracker = () => {
    // @ts-ignore
    if (App.Config.Controller !== 'product') {
        removeItemsParameters();
    }
};
